import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { MongoResource } from '../../shared/mongo.resource';
import { HttpClient } from '@angular/common/http';

// @Injectable()
// export class AnnouncementsService {

//     constructor() { }

// }

@Injectable()
export class UserlogsService extends MongoResource<any, any, any> {

  baseUrl = environment.api + 'logs';

  getDownloads(): Observable<any[]> {
    return this.$get('downloads');
  }


  getLog(): Observable<any> {
    return this.$get('');
  }

  constructor(public http: HttpClient) { super(http); }

}



// WEBPACK FOOTER //
// /ng-app/src/app/dashboard/shared/userlogs.service.ts